/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class LogoView {
	constructor(
		public readonly ownerId: number,
		public readonly dataUrl: string | null,
	) {
		Object.freeze(this);
	}

	get hasImage(): boolean {
		return this.dataUrl !== null;
	}
}

export default LogoView;
